import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {fontType} from "../../constants/font";
import {courseGroups} from "../../data/courseGroups";
import CourseGroup from "./CourseGroup";

function Courses({
    courses,
    setContactForm,
    setContactMessage,
    fetchedData,
    windowWidth
}) {
    const [ref, inView] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });

    const openForm = () => {
        setContactForm(true);
        setContactMessage("");
    };

    return (
        <Box>
            <Box
                sx={{
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "center",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        maxWidth: "1440px",
                        width: "100%",
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            marginTop: { sm: "60px", xs: "35px" },
                            marginBottom: "50px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 2,
                            position: "relative",
                        }}
                    >
                        <motion.div
                            ref={ref}
                            initial={{ opacity: 0, y: 50 }}
                            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                            transition={{ duration: 0.7 }}
                        >
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    fontFamily: fontType.regular,
                                    fontSize: 38,
                                    color: "#1d1a56",
                                    marginBottom: "15px",
                                    lineHeight: "40px",
                                }}
                            >
                                Školenia
                            </Typography>
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    fontFamily: fontType.regular,
                                    fontSize: 22,
                                    lineHeight: "28px",
                                    color: "#1d1a56",
                                    maxWidth: "480px",
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                }}
                            >
                                Ponúkame školenia formou <span style={{ fontFamily: fontType.semiBold }}>online</span> výuky. Možnosť aj{" "}
                                <span style={{ fontFamily: fontType.semiBold }}>onsite školení</span> na základe dohody.
                            </Typography>
                        </motion.div>
                        <div id="course-list"></div>
                        <Link
                            onClick={() => openForm()}
                            style={{
                                textAlign: "center",
                                fontFamily: fontType.semiBold,
                                fontSize: 22,
                                lineHeight: "28px",
                                color: "#1d1a56",
                                decoration: "underline",
                            }}
                        >
                            kontaktovať
                        </Link>
                    </Box>
                </Box>
            </Box>
            {
                Object.entries(courseGroups).map(([group, groupCourses]) => {
                    return (
                        <CourseGroup
                            key={group}
                            group={group}
                            groupCourses={groupCourses}
                            courses={courses}
                            fetchedCourseData={fetchedData}
                            windowWidth={windowWidth}
                        />
                    )
                })
            }
        </Box>
    );
}

export default Courses;